<template>
  <div>
    <a-card title="Jesus Stories" class="style4 jesus-stories">
      <a-list :grid="{ gutter: 16, xs: 1, sm: 2, md: 3 }" :data-source="storyVideos">
        <a-list-item slot="renderItem" slot-scope="item" class="mt-4">
          <div class="story-video-item">
            <div class="video_thumb" @click="doOpenArticleVideo(item)">
              <img :src="item.video_thumbnail" />
              <div class="play_icon">
                <inline-svg :src="require('../../assets/images/video-play.svg')" width="36" height="36" />
              </div>
            </div>
            <h4>{{ item.user.firstname }} {{ item.user.lastname }}</h4>
            <a :href="appLink + '/story/' + item.slug"
              ><h6>{{ appLink }}/story/{{ item.slug }}</h6></a
            >
          </div>
        </a-list-item>
      </a-list>
    </a-card>
    <div class="row" style="text-align: center;">
      <div class="col-lg-12 mt-4">
        <div class="link-label font-helvetica">{{ $t('label.jesusStories') }}</div>
        <div class="link-value mt-2">
          <a :href="pageUrl" target="_blank">{{ pageUrl }}</a>
          <a-button type="primary" class="tf-btn tf-btn-primary clipboard-btn" v-clipboard:copy="pageUrl" v-clipboard:success="clipboardSuccess">
            <inline-svg :src="require('../../assets/images/clipboard.svg')" width="12" height="14" />
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { isEmpty, includes } from 'lodash';
import Constants from '@/constants.js';
import IntroVideoService from '@/services/IntroVideoService';
export default {
  data() {
    return {
      storyVideos: [],
      appLink: Constants.APP_URL,
    };
  },
  computed: {
    ...mapState(['settings', 'user']),
    isFreeEvangelism() {
      return includes(this.user.user.role, 'free_evangelism');
    },
    pageUrl() {
      console.log('------', this.user);
      const accountSlug = this.user.user.accountSlug;
      return Constants.APP_URL + `/jesusstorychallenge/${accountSlug}`;
    },
  },
  async mounted() {
    try {
      this.isLoading = true;
      this.storyVideos = await IntroVideoService.getStoryVideos(this.user.user.accountSlug);
    } catch (error) {
      console.log({ error });
    } finally {
      this.isShowCardOrder = this.userCardOrder.length === 0;
      this.isLoading = false;
    }
  },
  methods: {
    async doInitData() {
      try {
        console.log('---doInitData--');
      } catch (error) {
        console.log({ error });
      } finally {
        this.isShowCardOrder = this.userCardOrder.length === 0;
        this.isLoading = false;
      }
    },
    doOpenArticleVideo(item) {
      if (isEmpty(item.video_url)) {
        return;
      }

      this.openEmbedPage(item.video_url);
    },
    ...mapActions({
      openEmbedPage: 'openEmbedPage',
    }),
    clipboardSuccess() {
      this.$notification['success']({
        message: 'Copied to clipboard',
      });
    },
  },
};
</script>
<style lang="scss">
.jesus-stories {
  .ant-card-body {
    background-color: #333;
    .ant-spin-container {
      .story-video-item {
        background-color: white;
        padding: 8px;
        border-radius: 8px;
      }
    }
  }
}

.link-label {
  white-space: nowrap;
  flex: 0 0 auto;
  font-weight: 600;
  margin-right: 16px !important;
}
.link-value {
  margin-left: 8px;
  flex: 0 1 auto;
  word-break: break-all;

  & > a {
    color: #212b36;
    text-decoration: underline;
  }
}

.video_thumb {
  position: relative;
  width: 100%;
  height: auto;
  margin-bottom: 6px;
  cursor: pointer;

  &:hover .play_icon {
    color: #6aab2d;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 8px 8px 0 0;
    margin-bottom: 0;
    filter: brightness(0.7);
  }

  .play_icon {
    transition: color 200ms linear;
    color: white;
    position: absolute;
    width: 36px;
    height: 36px;
    left: 50%;
    top: 50%;
    margin-top: -18px;
    margin-left: -18px;
  }
}
</style>
